<template>
    <transition name="dropdown-content">
        <div
            class="dropdown-menu"
            :class="{'show' : dropDownState.active}"
        >
            <slot />
        </div>
    </transition>
</template>

<script setup>
import { inject, computed } from "vue";

// inject reactive value
const dropDownState = inject("dropDownState");

const active = computed(() => {
    return dropDownState.value.active;
});
</script>

